<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-input v-model="form.subCategoryName" placeholder="子品类名称" />
            </a-form-model-item>
            <a-form-model-item>
              <a-select v-model="form.categoryCode" placeholder="品类名称" style="width: 150px">
                <a-select-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-select v-model="form.status" placeholder="状态" style="width: 150px">
                <a-select-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button
                v-if="$getPermission($route.path + '/add')"
                @click="$router.push($route.path + '/add')"
                type="primary"
                >新建</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="品类名称">
          <template slot-scope="text">
            <DataDictFinder
              dictType="fixed_asset_type"
              :dictValue="text.categoryCode"
            />
          </template>
        </a-table-column>
        <a-table-column title="子品类名称" data-index="subCategoryName"> </a-table-column>
        <a-table-column title="子品类编码" data-index="subCategoryCode"> </a-table-column>
        <a-table-column title="报废方式" data-index="scrapMethod"> </a-table-column>
        <a-table-column title="报废时限(月)" data-index="scrapLimitMonths"> </a-table-column>
        <a-table-column title="净残值率" data-index="netSalvageRate"> </a-table-column>
        <a-table-column title="状态">
          <template slot-scope="text">
            <DataDictFinder
              dictType="fixed_asset_status_A"
              :dictValue="text.status"
              iconType="badge"
            />
          </template>
        </a-table-column>
        <a-table-column title="操作" align="right" width="120px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                @click.prevent="$router.push($route.path + '/edit?id=' + text.id)"
                v-if="$getPermission($route.path + '/edit')"
                >编辑</a
              >
              <a
                href="#"
                @click.prevent="deleteText(text)"
                style="color: #f5222d"
                v-if="$getPermission($route.path + '/edit')"
                >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import { mapGetters } from "vuex";

function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset-category/list",
    data,
    method: 'post'
  });
}
function deleteCategory(id) {
  return request({
    url: "/office-service/fixed-asset-category/delete/" + id,
    method: 'post'
  });
}

export default {
  mixins: [watermark],

  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("fixed_asset_status_A");
    }
  },

  mounted() {
    this.getList();
  },

  methods: {
    deleteText(text) {
      this.$confirm({
        title: "删除确认",
        content: `确认删除 "${text.subCategoryName}" 吗？`,
        onOk: () => {
          deleteCategory(text.id)
           .then(() => {
              this.getList();
            })
           .catch(() => {
              this.$message.error("删除失败");
            });
        },
      });
    },
    getList() {
      const { current, pageSize, form } = this;

      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    }
  },
};
</script>